import React, { useState } from 'react'
import {Helmet} from "react-helmet";
import { DEMO_REQUEST } from '../../../content/data/contactPages'
import Layout from '../../components/Layout'

import InnerLayout from '../../components/InnerLayout'
import HubspotForm from 'react-hubspot-form'

const rawMeetingHTML = `
<div class="meetings-iframe-container" data-src="https://meetings.hubspot.com/ruben-hakopian?embed=true"></div>
`

const DemoRequest = () => {
    const [isScheduling, setIsScheduling] = useState(false);
    const pageData = DEMO_REQUEST;


    return (
        <>
            <Layout
                title={pageData.mainTitle}
                devTitle={pageData.devTitle}
                
                backgroundImg="/img/contactPages/message.svg"
                seoTitle="Kubevious :: Demo Request"
                seoDescription={pageData.subTitle}
            >
                <InnerLayout>
                    <HubspotForm
                        portalId={pageData.hubspotPortalId}
                        formId={pageData.hubspotFormId}
                        onSubmit={(formData) => {
                            // formData.push({name: 'reason', value: 'web-site-test'})
                            // console.log("[onFormSubmit] ", formData);
                            setIsScheduling(true);
                        }}
                        onReady={() => {
                            // HACK: This script is a hack to make onSubmit callaback work.
                            const script = document.createElement('script');
                            script.src = 'https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js';
                            let jqueryScript = document.getElementsByTagName('script');
                            let src = Array.from(jqueryScript).filter(item => item.src === script.src)
                            if(src.length === 0) {
                              document.body.appendChild(script)
                            }
                        }}
                        // loading={<div>Loading...</div>}
                    />

                    {isScheduling && <div>
                        <div className="meetings-iframe-container"
                             data-src={pageData.hubspotMeetingUrl}>
                        </div>

                        <Helmet>
                            <script type="text/javascript"
                                    src="https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js">
                            </script>
                        </Helmet>
                    </div>}
                    
                </InnerLayout>
            </Layout>
        </>
    )
}

export default DemoRequest
